<nb-card style="width: 38rem;">
  <nb-card-header>{{title}}</nb-card-header>
  <nb-card-body class="text-justify">
    {{desc}}
  </nb-card-body>
</nb-card>
